export function startSubmitIndicator(button) {
  const
    buttonText = button.querySelector('.button-text'),
    spinner = button.querySelector('.spinner');
  buttonText.dataset['defaultText'] = buttonText.innerHTML;
  buttonText.innerHTML = 'Processing';
  spinner.classList.add('visible');
  button.disabled = true;
  const timer = setTimeout(() => stopSubmitIndicator(button), 65000);
  button.dataset['timerId'] = timer;
}

export function stopSubmitIndicator(button) {
  if (!button) {
    return;
  }
  const
    buttonText = button.querySelector('.button-text'),
    spinner = button.querySelector('.spinner');
  clearTimeout(button.dataset['timerId']);
  buttonText.innerHTML = buttonText.dataset['defaultText'];
  spinner.classList.remove('visible');
  button.disabled = false;
}
